const DocumentPreview = ({
  documents = [],
  zipSize = "5.23MB",
  className = "",
  svgHeight,
}) => {
  return (
    <div
      className={`relative w-full max-w-[350px] sm:max-w-[384px] h-[380px] mx-auto ${className}`}
    >
      {/* ===== CARD BACKGROUND ===== */}
      <div className="absolute top-[60px] w-full h-[300px] rounded-xl bg-navy-blue-06 z-0" />

      {/* ===== TOP IMAGES ===== */}
      <div className="absolute w-full flex justify-center items-start h-[200px] z-10">
        {/* LEFT */}
        {documents[0]?.img && (
          <img
            src={documents[0].img}
            alt="left"
            className="absolute left-[8%] top-[20px] w-[144px] h-[169px] rotate-[-4deg] z-10 shadow-md rounded"
          />
        )}

        {/* CENTER */}
        {documents[1]?.img && (
          <img
            src={documents[1].img}
            alt="center"
            className="relative w-[144px] h-[187px] z-20 shadow-md rounded"
          />
        )}

        {/* RIGHT */}
        {documents[2]?.img && (
          <img
            src={documents[2].img}
            alt="right"
            className="absolute right-[8%] top-[20px] w-[144px] h-[169px] rotate-[4deg] z-10 shadow-md rounded"
          />
        )}
      </div>

      {/* ===== CONTENT BOX ===== */}
      <div className="absolute top-[100px] w-full px-3 sm:px-5 z-20">
        {/* SVG BACKGROUND */}
        <div className="absolute top-0 left-0 w-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="274"
            preserveAspectRatio="none"
            viewBox="0 0 380 274"
            fill="none"
            className="h-[280px]"
          >
            <path
              d="M0 10V32.4242V264C0 269.523 4.47716 274 10 274H370C375.523 274 380 269.523 380 264V42.0152C380 36.4864 375.514 32.0068 369.985 32.0152L107.503 32.4139C103.408 32.4202 99.7225 29.9289 98.2022 26.1264L90.2701 6.2875C88.7519 2.49017 85.0744 0 80.9848 0H10C4.47715 0 0 4.47715 0 10Z"
              fill="#44476A"
            />
          </svg>
        </div>

        {/* CONTENT */}
        <div className="relative pt-3 flex flex-col gap-4">
          <p className="text-grey-01 text-[10.25px] md:text-[12px] font-medium text-start font-inter">
            Zip · {zipSize}
          </p>

          <p className="text-grey-01 text-[10px] md:text-[12px] text-start font-inter">
            What you’ll get?
          </p>

          <div className="flex flex-col gap-[10px] md:gap-3">
            {documents.map((doc, i) => (
              <>
                <div key={i} className="flex items-center gap-3">
                  <div className="flex w-[42px] aspect-square p-[4px_4px_0_4px] justify-center items-center rounded-[4px] bg-[#5B5D7C]">
                    <img
                      src={doc.img}
                      className="w-full h-auto rounded-sm"
                      alt="doc-preview-img"
                    />
                  </div>
                  <div>
                    <p className="text-grey-01 font-medium text-[14px] md:text-[16px] font-google">
                      {doc.title}
                    </p>
                    <p className="text-grey-03 text-[10px] md:text-[12px] font-inter">
                      {doc.pages}
                    </p>
                  </div>
                </div>
                {i < documents.length - 1 && (
                  <div className="w-full h-[1px] border-white/10 border-dashed border-t" />
                )}
              </>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentPreview;
